/**
 * Help Center Button - The ? icon that opens the Help Center
 */

import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useHelpCenter } from './HelpCenterContext';

export interface HelpCenterButtonProps {
  className?: string;
}

export function HelpCenterButton({ className = '' }: HelpCenterButtonProps) {
  const { openHelpCenter } = useHelpCenter();

  return (
    <button
      onClick={() => openHelpCenter()}
      className={`
          p-2 rounded-lg 
          text-theme-text-secondary
          hover:bg-theme-surface-hover 
          hover:text-primary-600
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
          ${className}
        `}
      title="Help Center"
      aria-label="Open Help Center"
    >
      <HelpCircle className="h-5 w-5" />
    </button>
  );
}
